import React, { FC, MouseEventHandler, PropsWithChildren } from 'react';
import { Icon, IIconProps } from '@/components/atomic/Icon';

export interface ILIconProps
  extends PropsWithChildren<Omit<IIconProps, 'onClick'>> {
  onClick?: MouseEventHandler<HTMLDivElement>;
}

const LIcon: FC<ILIconProps> = ({ children, className, onClick, ...props }) => (
  <div
    aria-label="پروفایل"
    className={`flex h-[48px] w-[48px] cursor-pointer items-center
                justify-center rounded-xl bg-[#fff] !text-green-30 md:rounded-lg
                ${className}`}
    role="button"
    onClick={onClick}
  >
    {children || <Icon ref={undefined as any} size={28} {...props} />}
  </div>
);

export default LIcon;
